module.exports = __webpack_public_path__ + "static/japan09-148989f0e15d644f0646d09651086f7c.jpg";